export const environment = {
    production: true,
    base: 'fpc.interspark.host',
    baseUrl: 'https://auth.fpc.interspark.host/api/v1',
    authUrl: 'https://auth.fpc.interspark.host/api',
    applicationBaseUrl: 'https://auth.fpc.interspark.host',
    applicationAuthUrl: 'https://auth.fpc.interspark.host',
};
